import { Component, signal, WritableSignal, Pipe, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { BreadcrumbComponent } from '@app/lib/components/breadcrumb/breadcrumb.component';
import { IBreadcrumb } from '@app/lib/models/breadcrumb.model';
import { TAny, TKeyValue } from '@app/lib/models/common.type';
import { ECaseCategory } from '../models/constant';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CloseTaskData, TaskTypeNames, TaskTypes } from '../models/close-task.model';
import { MatSortModule } from '@angular/material/sort';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ICaseItem, ICaseSearchRequestBody, ISearchRequestParams } from '../models/case-assignment.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, filter, switchMap, tap } from 'rxjs';
import { DocumentReceptionService } from '../services/document-reception.service';
import { IResponse } from '@app/lib/models/response.model';
import { ILoginData } from '@app/lib/models/login.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CloseTaskService } from '../services/close-task.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogService } from '@app/lib/services/dialog.service';
import { AlphaNumSlashDirective } from '@app/shared/alpha-num-slash.directive';
import { ECourtId } from '@app/dashboard/models/constant';
import { CaseNumberSearchComponent } from '../widget/case-number-search/case-number-search.component';


@Component({
  selector: 'app-close-task',
  standalone: true,
  imports: [BreadcrumbComponent,
          MatFormFieldModule,
          MatDatepickerModule,
          MatSelectModule,
          ScrollingModule,
          MatTableModule,
          MatSortModule,
          CommonModule,
          FormsModule,
          MatProgressSpinnerModule,
          MatProgressBarModule,
          MatIconModule,
          MatFormFieldModule,
          ReactiveFormsModule,
          MatAutocompleteModule,
          MatCheckboxModule,
          MatInputModule,
          MatButtonModule,
          AlphaNumSlashDirective,
          CaseNumberSearchComponent
        ],
  templateUrl: './close-task.component.html',
  styleUrl: './close-task.component.scss'
})
export class CloseTaskComponent implements OnInit {

  
  public caseCategoryEnum = ECaseCategory;

  isLoading:boolean=false;
  isTaskLoading:boolean=false;
  isSupremeCourtFlg:boolean=false;
  isCOAFlg:boolean=false;
  userType: string ="";
  courtData: ILoginData | null = null;
  disableTaskDropdown = false;
  taskTypeName: TaskTypeNames[] = [];
  isSaveLoading:boolean=false;
  public dataSource: MatTableDataSource<CloseTaskData> = new MatTableDataSource();
  displayedColumns: string[] = ['tasksId', 'taskTypeName', 'caseId', 'caseCourtCaseNumber', 'tasksDue', 'comment','actions'];
  public caseListLoader: WritableSignal<boolean> = signal(false);
  public caseList: WritableSignal<ICaseItem[]> = signal([]);
  public breadcrumbs: WritableSignal<IBreadcrumb[]> = signal([
      { label: 'Masters' },
      { label: 'Close Tasks' },
    ]);
  public taskTypes: TaskTypes[] = [];
  public caseDisplayFn(item: ICaseItem) {
        return item && item.caseNumber;
      }
  public searchForm: FormGroup = new FormGroup({
      caseNumber: new FormControl(''),
      taskId: new FormControl('',),
      taskTypeName: new FormControl(null),
    });
 
  public caseCategories: TKeyValue[] = [
      { key: this.caseCategoryEnum.FI, value: 'First Instance' },
      { key: this.caseCategoryEnum.A, value: 'Appeal' },
    ];
  constructor(
        private service: DocumentReceptionService,
        private closeTaskService:CloseTaskService,
        private dialog: MatDialog,
        private router: Router, 
        private dialogService: DialogService,
      ) {
        this.searchbyCaseNoChange();   
         this.searchForm.setValidators(() => {
  const caseNumberControlValue = this.searchForm.get('caseNumber')?.value;
const caseNumber = typeof caseNumberControlValue === 'string'
  ? caseNumberControlValue.trim()
  : caseNumberControlValue?.caseNumber?.trim() || '';
  const taskId = this.searchForm.get('taskId')?.value?.trim();
  return caseNumber || taskId ? null : { atLeastOneRequired: true };
});   
          
      }
   ngOnInit(): void {
    this.loadCourtData();
    this.getTaskType();   
  }

 getTaskType(): void {
  this.closeTaskService.getTaskType().subscribe({
    next: (res: IResponse<TaskTypeNames[]>) => {
      this.taskTypeName = (res.data || res.success || []).sort((a, b) =>
        a.taskName.localeCompare(b.taskName)
      );
      this.isTaskLoading = false;
    },
    error: () => {
      this.isTaskLoading = false;
    }
  });
}



  public resetHandler() {
    this.searchForm.reset();
    this.dataSource=new MatTableDataSource();
    this.isLoading=false;
    this.isTaskLoading=false;
      
    }
   public searchHandler() {
    this.searchForm.markAllAsTouched();
    if (this.searchForm.invalid) return;

    this.isLoading = true;
    this.dataSource.data = [];
    const selectedTask = this.searchForm.get('taskTypeName')?.value;
    const caseNumberControlValue = this.searchForm.get('caseNumber')?.value;

    const caseNumber =
      typeof caseNumberControlValue === 'string'
        ? caseNumberControlValue.trim()
        : caseNumberControlValue?.caseNumber || '';
    const reqBody = {
      "caseCourtCaseNumber": caseNumber,
      "courtId": "",
      "tasksId": this.searchForm.get('taskId')?.value ?? '',
      "taskTypeName": selectedTask?.taskName ?? '',
      "taskTypeId": selectedTask?.taskId ?? '',
      "caseCategory": ""
    };

    this.closeTaskService.searchCase(reqBody).subscribe({
      next: (res: IResponse<CloseTaskData[]>) => {
        if (res && res.data) {
          this.dataSource.data = res.data.map(item => ({
            ...item,
            isLoading: false
          }));

        } else {
          this.dialogService.openDialog1({
            data: {
              title: "Information",
              message: 'No Privilege to access the data (or) No Data Exists',
              icon: 'info', // ✅ Default icon if not provided
            }, disableClose: true,           // Prevents closing on outside click or ESC
            hasBackdrop: true,            // Shows backdrop to block interaction
            backdropClass: 'dialog-backdrop', // Optional: custom styling
          });
        }
        this.isLoading = false
      },
      error: (err) => {
        console.error('Error fetching case data:', err);
        this.isLoading = false;
      },
    });
  }
  public onCaseSearchOptionSelected(item: any): void {
    const caseNo = item?.caseNumber || item?.courtCaseNumber || '';
    if (caseNo) {
      this.searchForm.patchValue({ caseNumber: caseNo });
    }
  }
  private searchbyCaseNoChange() {
        this.searchForm.controls['caseNumber'].valueChanges
          .pipe(
            takeUntilDestroyed(),
            filter(val => {
              if (typeof val === 'string' && val.trim().length > 3) {
                this.caseListLoader.set(true);
                return true;
              }
              this.caseListLoader.set(false);
              return false;
            }),
            debounceTime(500),
            switchMap((searchVal: string) => this.searchCases(searchVal))
          )
          .subscribe({
            next: (res: IResponse<ICaseItem[]>) => {
              this.caseList.set(res.data);
              this.caseListLoader.set(false);
            },
            error: () => {
              this.caseListLoader.set(false);
            }
          });
      }
     private searchCases(val: string) {
          const body: ICaseSearchRequestBody = {
            caseNumber: val,
            dateOfFiling: 'null'
          };
          const params: ISearchRequestParams = {
            page: 1,
            start: 0,
            limit: 25,
            property: 'id',
            direction: 'ASC'
          }
          return this.service.searchCaseNumber(body, params);
        }
  getCourtNameData(): ILoginData | null {
        try {
            const userData = localStorage.getItem('userData') as string;
            return userData ? JSON.parse(userData) : null;
        } catch (err) {
            return null
        }
        
      }
      
      loadCourtData(): void {
        this.courtData = this.getCourtNameData();
         if (this.courtData && this.courtData.courtId === ECourtId.SC_ID) {
                
                this.isSupremeCourtFlg = true;
              } else if (this.courtData && this.courtData.courtId === ECourtId.COA_ID) {
                this.isCOAFlg = true;
              }
          console.log('Loaded Court Data:', this.courtData);
        this.userType= this.courtData?.courtId===1||this.courtData?.courtId===2?'admin':'lawyer'; // Change to 'admin', 'judge', etc.
      }
    onTaskTypeDropdownClick(): void {
      
      const caseNumber = this.searchForm.get('caseNumber')?.value;
      const taskId = this.searchForm.get('taskId')?.value;

      if (!caseNumber && !taskId) {
        // Optional: prevent opening the dropdown by disabling temporarily
        this.disableTaskDropdown = true;

        // Show your dialog/snack bar here
        alert('Please enter either Case Number or Task ID before selecting Task Type.');

        // Re-enable after a delay or next tick
        setTimeout(() => {
          this.disableTaskDropdown = false;
        });
      }
}
onCloseTask(data:CloseTaskData):void{
  if(this.isSaveLoading){
    return;
  }
   if (!data.comment || data.comment.trim() === '') {
    this.dialogService.openDialog1({
      data: {
        title: "Information",
        message: "Please enter a comment before closing the task.",
        icon: 'warning',
      },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });
    return;
  }
   this.isSaveLoading=true;
              const reqBody=[
                      {
                          "tasksId": data.tasksId,
                          "taskTypeName": data.taskTypeName,
                          "caseCourtCaseNumber": data.caseCourtCaseNumber,
                          "caseId": data.caseId,
                          "tasksDue": data.tasksDue,
                          "notDoneReason": data.comment,
                          "taskTypeId": data.taskTypeId,
                          "courtId": data.courtId,
                          "transType": "U"
                      }
                  ]
            
              this.closeTaskService.onCloseTask(reqBody).subscribe({
                next: (res: IResponse<TAny[]>) => {
                    if (res && res.success) {
                    this.dialogService.openDialog1( {
                      data: {
                        title: "Success",
                        message: res.message,
                        icon: 'success', // ✅ Default icon if not provided
                      }, disableClose: true,           // Prevents closing on outside click or ESC
          hasBackdrop: true,            // Shows backdrop to block interaction
          backdropClass: 'dialog-backdrop', // Optional: custom styling
                    });
                    this.dataSource=new MatTableDataSource;
                    this.searchForm.reset();

                  }else{
                    this.dialogService.openDialog1( {
                      data: {
                        title: "Information",
                        message: res.message,
                        icon: 'info', // ✅ Default icon if not provided
                      }, disableClose: true,           // Prevents closing on outside click or ESC
          hasBackdrop: true,            // Shows backdrop to block interaction
          backdropClass: 'dialog-backdrop', // Optional: custom styling
                    });
                  }
                  this.isSaveLoading=false
                },
                error: (err) => {
                  console.error('Error fetching case data:', err);
                  this.isSaveLoading=false;
                },
              });

}

}
